import React, { useState, useContext } from 'react';
import axios from 'axios';
import { UserContext } from '../context/UserContext'
import Cropper from 'react-easy-crop';
import CropAvatar from './CropAvatar'; // Import helper for cropping logic
import '../styles/Profile.css'; // Import styles
import backendUrl from '../BackendUrl';

const UploadAvatar = () => {
  const [previewUrl, setPreviewUrl] = useState(null); // State for previewing the selected image
  const [isUploading, setIsUploading] = useState(false); // State to indicate upload progress
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedImage, setCroppedImage] = useState(null);
  const [cropArea, setCropArea] = useState(null);
  const [isCropping, setIsCropping] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);

  const { user, setUser } = useContext(UserContext);

  // Handle file selection
  const handleFileChange = (e) => {
    setIsProcessing(true);
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setPreviewUrl(URL.createObjectURL(selectedFile)); // Create a preview URL for the file
      setIsCropping(true); // Enable cropping mode
    }
  };

  // Handle cropping completion
  const handleCropComplete = async (croppedArea, croppedAreaPixels) => {
    setCropArea(croppedAreaPixels);
  };

  // Finalize the cropped image
  const finalizeCrop = async () => {
    if (!previewUrl || !cropArea) return;

    const cropped = await CropAvatar(previewUrl, cropArea, 'circle');
    setCroppedImage(cropped);
    setIsCropping(false); // Exit cropping mode
  };

  // Handle the image upload
  const handleUpload = async () => {
    if (!croppedImage) {
      alert('Please crop the image before uploading.');
      return;
    }

    try {
      setIsUploading(true);

      const authToken = localStorage.getItem('authToken');
      if (!authToken) {
        alert('Authentication token not found. Please log in.');
        setIsUploading(false);
        setIsProcessing(false);
        return;
      }

      // Get the user ID from the context
      const userId = user?.id; // Assuming user is available in the context

      if (!userId) {
        alert("User ID not found.");
        setIsUploading(false);
        setIsProcessing(false);
        return;
      }

      const response = await axios.post(
        `${backendUrl}/api/accounts/upload`,
        {
          file: croppedImage,
          fileName: userId,
        },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
            'Content-Type': 'application/json',
          },
        }
      );

      const { avatarImg } = response.data;
      alert('Avatar uploaded successfully!');

      // Update user state and localStorage with the new avatarImg
      setUser((prevUser) => {
        const updatedUser = {
          ...prevUser,
          avatarImg: avatarImg, // Update avatarImg in user state
        };
        // Persist updated avatarImg in localStorage
        localStorage.setItem('user', JSON.stringify(updatedUser));
        return updatedUser;
      });
      setIsUploading(false);
      setIsProcessing(false);
    } catch (error) {
      console.error('Error uploading avatar:', error);
      alert('Failed to upload avatar. Please try again.');
      setIsUploading(false);
      setIsProcessing(false)
    }
  };

  return (
    <>
      {!isProcessing && (
        <button 
          className="change-image-button" 
          onClick={() => document.getElementById('fileInput').click()}
        >
          Change Image
        </button>
      )}
      <input
        id="fileInput"
        type="file"
        accept="image/*"
        onChange={handleFileChange}
        className="file-input"
        disabled={isUploading}
      />

      {isCropping && previewUrl && (
        <div className="cropper-overlay">
          <div className="cropper-container">
            <Cropper
              image={previewUrl}
              crop={crop}
              zoom={zoom}
              aspect={1}
              cropShape="round"
              onCropChange={setCrop}
              onZoomChange={setZoom}
              onCropComplete={handleCropComplete}
            />
          </div>
          <button className="crop-button" onClick={finalizeCrop}>
            Crop Image
          </button>
        </div>
      )}

      {isProcessing && croppedImage && (
        <div className="cropped-preview-overlay">
          <div className="cropped-preview-container">
            <img
              src={croppedImage}
              alt="Cropped Preview"
              className="cropped-preview"
            />
            <button 
              className="upload-button" 
              onClick={handleUpload} 
              disabled={isUploading}
            >
              {isUploading ? 'Uploading...' : 'Upload Image'}
            </button>
            <button 
              className="upload-button" 
              onClick={() => {
                setPreviewUrl(null); // Clear the preview URL
                setCroppedImage(null); // Clear the cropped image
                setIsProcessing(false); // Reset processing state
                setIsCropping(false); // Reset cropping state
                setCrop({ x: 0, y: 0 }); // Reset crop position
                setZoom(1); // Reset zoom level
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default UploadAvatar;